const { debounce } = require('../utils/debounce');
const { a11yClick } = require('../utils/a11yClick');

const $ = window.jQuery;
const $window = window.$window || $(window);

module.exports = {
	init: function () {
		/**
		 *
		 * CUSTOM STARTS HERE
		 *
		 */

		/**
		 * Menu Toggle
		 */
		$(document).on('click keypress', '.menu-toggle', function (e) {
			if (a11yClick(e) === true) {
				e.preventDefault();

				var $toggle = $(this),
					$wrapper = $toggle.parent().find('.menu-wrapper'),
					$additional = $('.menu-toggled');

				if ($wrapper.hasClass('active')) {
					$additional.fadeOut(150);
					$wrapper.fadeOut(150, function () {
						$wrapper.removeClass('active');
					});
				} else {
					$additional.css('display', 'flex').hide().fadeIn(150);
					$wrapper
						.css('display', 'flex')
						.hide()
						.fadeIn(150, function () {
							$wrapper.addClass('active');
						});
				}
			}
		});

		/**
		 * Schwarzes Brett Checkbox active
		 */
		$(document).on('change', '.checkbox-term input[name="schwarzes-brett_cats"]', function () {
			var $parent = $(this).parents('.checkbox-term');

			if (this.checked) {
				$parent.find('label').addClass('active');
				$parent.siblings().find('label').removeClass('active');
			} else {
				$parent.find('label').removeClass('active');
			}
		});

		/**
		 * Expand Search Bar
		 */
		$(document).on('click', '.header-icons__search', function (e) {
			if (a11yClick(e) === true) {
				e.preventDefault();

				var searchBar = $(this).parent().parent().find('.search-bar'),
					searchInput = searchBar.find('.proinput input.orig'),
					speed = 150;

				if (searchBar.is(':visible')) {
					searchBar.slideUp(speed);
				} else {
					searchBar
						.css('display', 'flex')
						.hide()
						.slideDown(speed, function () {
							searchInput.focus();
						});
				}
			}
		});

		$(document).on(
			'mouseup.zmbDropdown touchend.zmbDropdown focusin.zmbDropdown',
			function (e) {
				var container = $('.search-bar:visible');
				var searchResults = $('#ajaxsearchprores1_1:visible');

				if (!container.is(e.target) && container.has(e.target).length === 0) {
					container.slideUp(150);
					searchResults.slideUp(150);
				}
			},
		);

		$(document).on('keydown.zmbDropdown', function (e) {
			var searchResults = $('#ajaxsearchprores1_1:visible');

			if (e.which == 27) {
				$('.search-bar').slideUp(150);
				searchResults.slideUp(150);
			}
		});

		$('.slideshow').slick({
			prevArrow:
				'<button aria-label="Zurück" class="absolute group inset-y-half left-0 z-10">\
                <span class="block relative p-4 border-2 border-white bg-white opacity-50 group-hover:opacity-100 group-focus:opacity-100 rounded-full transition duration-150">\
                    <span class="absolute top-0 left-0 w-full h-full flex items-center justify-center text-[2rem] font-bold leading-0 text-black">&#8592;</span>\
                </span>\
            </button>',

			nextArrow:
				'<button aria-label="Weiter" class="absolute group block inset-y-half right-0 z-10">\
                <span class="block relative p-4 border-2 border-white bg-white opacity-50 group-hover:opacity-100 group-focus:opacity-100 rounded-full transition duration-150">\
                    <span class="absolute top-0 left-0 w-full h-full flex items-center justify-center text-[2rem] font-bold leading-0 text-black">&#8594;</span>\
                </span>\
            </button>',
		});
	},
};
